<div class="subtitle" *ngIf="!displayMessage">{{ subtitleWidget }}</div>

    <div class="table-container" #tableProductionContainer>
        <div
            class="container-flex"
            [ngStyle]="{
                paddingBottom:
                    dataTable?.tHead?.rangePeriods?.length > 16 ? '8px' : '0'
            }"
        >
            <div
                [ngClass]="{
                    'container-item-1': i === 0,
                    'container-item-2': i === 1
                }"
                *ngFor="let row of dataTable?.tHead?.header; index as i"
            >
                {{ row }}
            </div>

            <ng-container *ngFor="let machine of dataTable?.tBody; index as j">
                <div class="container-item-1">
                    <p class="sub-item-1">{{ machine.name }}</p>
                    <p class="sub-item-2">
                        {{ "cumulative" | lang | titlecase }}
                    </p>
                </div>
                <div class="container-item-2">{{ machine.loops }}</div>
            </ng-container>

            <div
                *ngFor="let row of dataTable?.tFooter?.totalValue; index as k"
                [ngClass]="{
                    'container-item-1': k === 0,
                    'container-item-2': k === 1
                }"
            >
                {{ row }}
            </div>
        </div>
        <div
            class="table-production"
            [ngStyle]="{
                overflowX:
                    dataTable?.tHead?.rangePeriods?.length > 16
                        ? 'auto'
                        : 'visible'
            }"
        >
            <table class="table-main" aria-label="table-widget-thirty-minutes">
                <thead>
                    <tr>
                        <th
                            scope="col"
                            class="periods"
                            *ngFor="let range of dataTable?.tHead?.rangePeriods"
                        >
                            <div>
                                {{ range.periodStartTime?.slice(11, 16) }}
                            </div>
                            <div>{{ range.periodEndTime?.slice(11, 16) }}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let machine of dataTable?.tBody; index as j">
                        <td
                            class="loops-machine"
                            *ngFor="let loops of machine.loopsByMachine"
                            [ngClass]="{ odd: j % 2 !== 0, even: j % 2 === 0 }"
                        >
                            <div class="loops">{{ loops.loopsMachine }}</div>
                            <div class="loops-accum">
                                {{ loops.accumLoops }}
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td
                            *ngFor="
                                let loops of dataTable?.tFooter
                                    ?.totalLoopsPeriod;
                                index as k
                            "
                            class="loops-machine"
                            [ngClass]="{
                                even: isEvenNumberMachines,
                                odd: !isEvenNumberMachines
                            }"
                        >
                            <span class="loops">{{ loops }}</span>
                        </td>
                    </tr>
                </tfoot>
            </table>
            <ng-container *ngIf="clockData?.positionClockBg?.length">
                <div
                    class="table-clock-bg"
                    *ngFor="let clock of clockData?.positionClockBg"
                    [ngStyle]="{
                        left: clock + 'px',
                        height: clockData?.heightClock + 'px',
                        width: clockData?.widthClockBg + 'px'
                    }"
                ></div>
            </ng-container>
            <app-clock *ngIf="showClock" [clockData]="clockData"> </app-clock>
        </div>
        <div class="separator" [ngStyle]="{ height: heightClock + 'px' }"></div>

</div>
